export const SelectCardInformation = [
  {
    id: '1',
    image: 'book',
    title: 'Book',
    description1:
      'Utilizza il nostro servizio di ricerca per prenotare le tue esperienze wellness. Esplora il catalogo di attività e scopri tutte le esperienze pensate per il tuo benessere.',
    description2: 'Sfoglia il catalogo di attività ed esperienze',
    description3: 'Scopri tutte le esperienze wellness',
  },
  {
    id: '2',
    image: 'read',
    title: 'Read',
    description1: 'Tutti i migliori consigli e suggerimenti per il tuo benessere, per aiutarti a vivere una vita sana e equilibrata.',
    description2: 'Migliori consigli per il tuo benessere',
    description3: '',
  },
  {
    id: '3',
    image: 'video',
    title: 'Video',
    description1:
      'Lezioni online per il tuo benessere: accedi facilmente a video-lezioni da qualsiasi luogo e migliora il tuo equilibrio fisico e mentale.',
    description2: 'Accedi via internet a lezioni video da qualsiasi posto',
    description3: '',
  },
];
